<template>
  <div>
    <div class="row top">
      <div class="row">
        <div class="col-md-2">
          <back-button returnUrl="/home"></back-button>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <h4><u>Κινητές Συσκευές</u></h4>
        </div>
      </div>

      <div class="col-md-1" style>
        <DxLoadIndicator
          id="image-indicator"
          :height="40"
          :width="40"
          :visible="loadIndicatorVisible"
        />
      </div>
    </div>

    <div class="grid-pad">
      <DxDataGrid
        @initialized="saveGridInstance"
        :data-source="mobiles"
        :allow-column-reordering="true"
        :allow-column-resizing="true"
        :column-auto-width="true"
        :show-borders="true"
        key-expr="Id"
        @row-inserting="onRowInserting"
        @row-updating="onRowUpdating"
        @init-new-row="onInitNewRow"
        :show-row-lines="true"
        :row-alternation-enabled="true"
        @editor-preparing="onEditorPreparing"
        @row-removing="onRowRemoving"
        @row-validating="onRowValidating"
      >
        <DxPaging :page-size="20" />
        <DxEditing
          :allow-updating="true"
          :allow-adding="true"
          :allow-deleting="true"
          mode="row"
          :use-icons="true"
        />
        <DxHeaderFilter :visible="true" />
        <DxFilterRow :visible="true" />
        <DxSearchPanel :visible="true" />

        <!-- <DxColumn  caption="Κωδικός" data-field="Id" data-type="integer" :visible="false">                    
                </DxColumn> -->
        <DxColumn
          caption="Φορέας"
          data-field="OrganizationId"
          data-type="int32"
          alignment="left"
          :visible="true"
          :allow-updating="false"
        >
          <DxLookup
            :data-source="organizations"
            value-expr="Id"
            display-expr="Description"
          />
          <DxRequiredRule message="Ο Φορέας είναι υποχρεωτικός" />
        </DxColumn>

        <DxColumn
          caption="Αριθμός Κινητού"
          data-field="MobileNumber"
          data-type="string"
          alignment="left"
          :allow-updating="false"
        >
          <DxRequiredRule message="ο Αριθμός Κινητού είναι υποχρεωτικός" />
        </DxColumn>

        <DxColumn
          caption="PIN"
          data-field="OneTimePassword"
          data-type="string"
          alignment="left"
          :visible="false"
        >
          <!-- <DxRequiredRule message="το Pin είναι υποχρεωτικό" /> -->
        </DxColumn>

        <DxColumn
          caption="PIN Ενεργό μέχρι"
          data-field="Id"
          data-type="date"
          :visible="false"
        >
        </DxColumn>

        <DxColumn
          caption="Ενεργοποιημένος"
          data-field="IsAuthenticated"
          data-type="boolean"
          width="150px"
          alignment="center"
        >
          <!-- <DxRequiredRule message="η κατάσταση είναι υποχρεωτική"/> -->
        </DxColumn>

        <DxColumn
          caption="Ενεργός"
          data-field="IsActive"
          data-type="boolean"
          width="150px"
          alignment="center"
        >
          <!-- <DxRequiredRule message="η κατάσταση είναι υποχρεωτική"/> -->
        </DxColumn>

        <DxMasterDetail :enabled="true" template="masterDetailTemplate" />
        <DxValidationSummary />
        <template #masterDetailTemplate="{ data: masterrow }">
          <DetailTemplate :template-data="masterrow" />
        </template>
      </DxDataGrid>
    </div>
  </div>
</template>

<script>
import router from "../../router";
import mainService from "../../services/mainService";
import {
  DxDataGrid,
  DxColumn,
  DxHeaderFilter,
  DxEditing,
  DxPaging,
  DxRequiredRule,
  DxLookup,
  DxMasterDetail,
  DxAsyncRule,
  DxFilterRow,
  DxSearchPanel,
} from "devextreme-vue/data-grid";
import DxValidationSummary from "devextreme-vue/validation-summary";
import DetailTemplate from "./mobileStructures";
import notify from "devextreme/ui/notify";
import BackButton from "../../components/shared/backButton";
import { DxLoadIndicator } from "devextreme-vue/load-indicator";

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxEditing,
    DxPaging,
    DxRequiredRule,
    DxLookup,
    DetailTemplate,
    DxMasterDetail,
    //DxAsyncRule,
    DxValidationSummary,
    DxFilterRow,
    DxSearchPanel,
    BackButton,
    DxLoadIndicator,
  },
  data() {
    return {
      mobiles: [],
      organizations: [],
      dataGridInstance: null,
      loadIndicatorVisible: false,
    };
  },
  methods: {
    saveGridInstance: function (e) {
      this.dataGridInstance = e.component;
    },

    onInitNewRow(e) {
      e.data.IsActive = true;
      e.data.OrganizationId = this.organizationId;
    },
    async onRowRemoving(e) {
      const res = await mainService.delete(
        `/Mobiles/DeleteMobile?mobileId=${e.data.Id}`
      );
      if (res.data == false) {
        e.cancel = true;
        notify("Αποτυχία διαγραφής.", "error", 5000);
      }
    },
    async onRowInserting(e) {
      //
      var mobile = e.data;

      try {
        var canExpand = true;
        const res = await mainService.post("/Mobiles/AddMobile", mobile);

        if (res.status != 200) {
          canExpand = false;
          e.cancel = true;
        }
        if (res.data.Message && res.data.Message != "") {
          e.cancel = true;
          notify(res.data.Message, "error", 5000);
        } else {
          notify("Η εγγραφή εισήχθει επιτυχώς", "success", 2000);
        }

        this.getMobiles();
        if (canExpand) {
          this.dataGridInstance.expandRow(res.data.Id);
        }
      } catch (error) {
        this.getMobiles();
        e.cancel = true;
      }
    },
    onEditorPreparing(e) {
      
      if (e.parentType == "dataRow") {
        if (e.dataField == "OrganizationId") e.editorOptions.readOnly = true;
        if (e.dataField == "IsAuthenticated") e.editorOptions.readOnly = true;
        if (e.dataField == "MobileNumber" && e.row.data.IsAuthenticated)
          e.editorOptions.readOnly = true;
      }
    },
    async onRowUpdating(e) {
      //
      var mobile = Object.assign(e.oldData, e.newData);
      mobile.Id = e.key;
      mobile.OrganizationId = this.organizationId;

      try {
        const res = await mainService.post("/Mobiles/UpdateMobile", mobile);
        if (res.status == 200 && res.data.Id == null) {
          e.cancel = true;
          await this.getOrganizations();
          await this.getMobiles();
          notify(res.data, "error", 5000);
        } else {
          notify("Η αποθήκευση πέτυχε", "success", 2000);
        }
      } catch (error) {
        e.cancel = true;
      }
      return;
    },
    onRowValidating(e) {
      // if (e.newData.OneTimePassword.length > 6) {
      //   e.errorText = "To PIN δεν μπορεί να είναι μεγαλύτερο από 6 χαρακτήρες.";
      //   e.isValid = false;
      // }
    },
    async getMobiles() {
      //
      this.loadIndicatorVisible = true;
      this.mobiles = [];

      try {
        const res = await mainService.get(
          `/Mobiles/GetAllMobiles?organizationId=${this.organizationId}`
        );
        if (res.status != 200) {
          notify(
            "Υπήρξε πρόβλημα κατά την ανάσυρση των κινητών",
            "error",
            1000
          );
        } else {
          this.mobiles = res.data;
          this.loadIndicatorVisible = false;
        }
      } catch (error) {
        notify("Υπήρξε πρόβλημα κατά την ανάσυρση των κινητών", "error", 1000);
      }

      return;
    },
    async getOrganizations() {
      this.organizations = [];
      const res = await mainService.get(`Organizations/GetOrganizations`);
      this.organizations = res.data;
    },
  },
  computed: {
    organizationId() {
      return this.$store.getters.getSelectedOrganizationId;
    },
  },
  watch: {
    organizationId: async function (newValue, oldValue) {
      this.dataGridInstance.collapseAll(-1);
      await this.getOrganizations();
      await this.getMobiles();
    },
  },

  async mounted() {
    this.getMobiles();
    this.getOrganizations();
  },
};
</script>

  <style scoped>
.dx-overlay-wrapper {
  max-width: 100px !important;
}

.dx-toast-message {
  width: 100px !important;
}
</style>